import { render } from "./RiderAccountLayout.vue?vue&type=template&id=c1432e86&scoped=true"
import script from "./RiderAccountLayout.vue?vue&type=script&lang=ts"
export * from "./RiderAccountLayout.vue?vue&type=script&lang=ts"

import "./RiderAccountLayout.vue?vue&type=style&index=0&id=c1432e86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c1432e86"

export default script